import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from './components/Footer/Footer';

ReactDOM.render(
    <App />,
  document.getElementById('root')

);

ReactDOM.render(
  <Footer />,
  document.getElementById('footer1')
);
